import './CustomPaginationComponent.scss'
import React from 'react'
import { PaginationComponentProps } from 'react-data-table-component'
import { PaginationChangeRowsPerPage } from 'react-data-table-component/dist/DataTable/types'
import { SelectDropdown, SelectOption } from '../SelectDropdown/SelectDropdown'
import styled from 'styled-components'

const CurrentPage = styled.div`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  color: #fff;
  border: 1px solid var(--gray-color-gray-900, #212529);
  background: var(--gray-color-gray-900, #212529);
`

export const CustomPaginationComponent: React.FC<PaginationComponentProps> = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => {
  const numPages = Math.ceil(rowCount / rowsPerPage)
  const lastIndex = currentPage * rowsPerPage
  const firstIndex = lastIndex - rowsPerPage + 1
  const disabledLesser = currentPage === 1
  const disabledGreater = currentPage === numPages

  const range = currentPage === numPages ? `${firstIndex}-${rowCount} of ${rowCount}` : `${firstIndex}-${lastIndex} of ${rowCount}`

  return (
    <div className='d-flex zocks-mt-2.0 gap-3 justify-content-end zocks-text-gray-900'>
      <div className='d-flex gap-2 align-items-center'>
        <div className='paragraph-small'>{range}</div>
        <div>
          <PaginationRowPerPageSelect rowsPerPage={rowsPerPage} onChangeRowsPerPage={onChangeRowsPerPage} currentPage={currentPage} />
        </div>
      </div>
      <div className='d-flex gap-1 align-items-center'>
        <PaginationButton onClick={() => onChangePage(1, rowCount)} disabled={disabledLesser}>
          <i className='bi bi-chevron-bar-left' />
        </PaginationButton>
        <PaginationButton onClick={() => onChangePage(currentPage - 1, rowCount)} disabled={disabledLesser}>
          <i className='bi bi-chevron-left' />
        </PaginationButton>
        <CurrentPage className='button-small'>{currentPage}</CurrentPage>
        <PaginationButton onClick={() => onChangePage(currentPage + 1, rowCount)} disabled={disabledGreater}>
          <i className='bi bi-chevron-right' />
        </PaginationButton>
        <PaginationButton onClick={() => onChangePage(numPages, rowCount)} disabled={disabledGreater}>
          <i className='bi bi-chevron-bar-right' />
        </PaginationButton>
      </div>
    </div>
  )
}

interface PaginationButtonProps {
  disabled?: boolean
  onClick?: () => void
  children?: React.ReactNode
}

const PaginationButton: React.FC<PaginationButtonProps> = ({ disabled = false, onClick, children }) => {
  const handleOnClick = () => {
    onClick && onClick()
  }

  return (
    <button className='pagination-button' disabled={disabled} onClick={handleOnClick}>
      {children}
    </button>
  )
}

const PaginationRowPerPageSelect: React.FC<{ rowsPerPage: number; onChangeRowsPerPage: PaginationChangeRowsPerPage; currentPage: number }> = ({
  rowsPerPage,
  onChangeRowsPerPage,
  currentPage,
}) => {
  const rowPerPageOptions = [
    { label: '10', id: '10' },
    { label: '20', id: '20' },
    { label: '50', id: '50' },
    { label: '100', id: '100' },
  ]
  const onOptionSelected = (option: SelectOption) => {
    onChangeRowsPerPage(parseInt(option.id), currentPage)
  }

  return (
    <SelectDropdown
      initialSelectedOption={rowPerPageOptions.find((option) => parseInt(option.id) === rowsPerPage)}
      options={rowPerPageOptions}
      className='px-2 py-1 paragraph-small'
      onOptionSelected={onOptionSelected}
    />
  )
}
